import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@careflux/primitives';
import type { VerificationTableProps } from './components.types';
import { SUPPRESSED_LABEL, UNKNOWN_LABEL, formatNumber, formatPercent, formatSeconds } from './formatting';
import { emptyStateClasses } from './summaryQuality.styles';

export const VerificationTable = ({ rows, dimensionLabel }: VerificationTableProps) => {
  if (rows.length === 0) return <div className={emptyStateClasses}>Engar ábendingar á völdu tímabili.</div>;

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{dimensionLabel}</TableHead>
          <TableHead className="text-right">Boðnar</TableHead>
          <TableHead className="text-right">Samþykktar</TableHead>
          <TableHead className="text-right">Hafnað</TableHead>
          <TableHead className="text-right">Ósvarað</TableHead>
          <TableHead className="text-right">Samþykktarhlutfall</TableHead>
          <TableHead className="text-right">Beitt</TableHead>
          <TableHead className="text-right">Miðgildi svartíma</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((row, index) => (
          <TableRow key={row.key ?? `unknown-${index}`}>
            <TableCell className="max-w-[240px] truncate">{row.key || UNKNOWN_LABEL}</TableCell>
            <TableCell className="text-right tabular-nums">{formatNumber(row.offered)}</TableCell>
            <TableCell className="text-right tabular-nums">{formatNumber(row.accepted)}</TableCell>
            <TableCell className="text-right tabular-nums">{formatNumber(row.rejected)}</TableCell>
            <TableCell className="text-right tabular-nums">{formatNumber(row.unanswered)}</TableCell>
            {row.suppressed ? (
              <TableCell colSpan={3} className="text-right text-muted-foreground">
                {SUPPRESSED_LABEL}
              </TableCell>
            ) : (
              <>
                <TableCell className="text-right tabular-nums">{formatPercent(row.acceptRate)}</TableCell>
                <TableCell className="text-right tabular-nums">{formatPercent(row.appliedRate)}</TableCell>
                <TableCell className="text-right tabular-nums">{formatSeconds(row.resolveP50Seconds)}</TableCell>
              </>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
